<header id="header-container" class="header-container mat-elevation-z6">
    <div id="header-title" class="header-title">
        MEMBER RESPONSE PORTAL
    </div>
    <div id="header-logo" class="header-logo">
        <img src="assets/machinify_logo_off_white.png" alt="Machinify Logo">
    </div>
</header>

